import { render } from "./K9HandlingView.vue?vue&type=template&id=d96bc112&scoped=true&ts=true"
import script from "./K9HandlingView.vue?vue&type=script&lang=ts"
export * from "./K9HandlingView.vue?vue&type=script&lang=ts"

import "./K9HandlingView.vue?vue&type=style&index=0&id=d96bc112&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d96bc112"]])

export default __exports__